import React from "react";

import styled from "styled-components";
import { useSelector } from "react-redux";
import {
    PathwayCenteredTableCellContent,
    PathwayCenteredTableHeader,
    PathwayTable,
    PathwayTableCellContent,
    PathwayTableContentRow,
    PathwayTableHeader,
    PathwayTableHeaderRow,
    TableContentDividerLine,
} from "../../../_UI/StyledComponents/PathwayTable";
import { PathwayAddButton, PathwayDeleteButton, PathwayEditButton } from "../../../_UI/Components/PathwayButtons";
import { getClientNameForConnectedAuthData, mapConnectAuthDataTypeToIntegrationName } from "../services/client.mapper";
import { getIntegrationIcon, getIntegrationSquareLogo } from "../../../_statics/IntegrationBrand";

const APIConnectionContent = (props) => {
    const clientReducer = useSelector((state) => state.client);

    return (
        <PathwayTable>
            <TableHeader>
                <PathwayTableHeader>Integration</PathwayTableHeader>
                <PathwayTableHeader>Name</PathwayTableHeader>
                <PathwayTableHeader>Url</PathwayTableHeader>
                <PathwayTableHeader>Shop / Account</PathwayTableHeader>
                <PathwayCenteredTableHeader>
                    <PathwayAddButton onClick={props.createNewConnectedAuthDataWithoutClient} />
                </PathwayCenteredTableHeader>
            </TableHeader>
            {clientReducer.usedConnectedAuthData.map((connectedAuthData) => (
                <>
                    <TableRow key={connectedAuthData.externalUUID}>
                        <PathwayTableCellContent>
                            <IntegrationCell>
                                {getIntegrationSquareLogo(connectedAuthData.type) ? (
                                    <IntegrationLogoImg
                                        src={getIntegrationSquareLogo(connectedAuthData.type)}
                                        alt=""
                                    />
                                ) : (
                                    <IntegrationIconFallback
                                        className={getIntegrationIcon(connectedAuthData.type)}
                                        aria-hidden="true"
                                    />
                                )}
                                {mapConnectAuthDataTypeToIntegrationName(connectedAuthData.type)}
                            </IntegrationCell>
                        </PathwayTableCellContent>
                        <PathwayTableCellContent>{connectedAuthData.title}</PathwayTableCellContent>
                        <PathwayTableCellContent>{connectedAuthData.endpoint}</PathwayTableCellContent>
                        <PathwayTableCellContent>
                            {getClientNameForConnectedAuthData(clientReducer.clients, connectedAuthData)}
                        </PathwayTableCellContent>
                        <PathwayCenteredTableCellContent>
                            <ButtonArea>
                                <PathwayEditButton
                                    onClick={() => props.openEditConnectedAuthDataModal(connectedAuthData)}
                                />
                                <PathwayDeleteButton
                                    onClick={() => props.openDeleteConnectedAuthDataModal(connectedAuthData)}
                                />
                            </ButtonArea>
                        </PathwayCenteredTableCellContent>
                    </TableRow>
                    <TableContentDividerLine />
                </>
            ))}
        </PathwayTable>
    );
};

export default APIConnectionContent;

const TableHeader = styled(PathwayTableHeaderRow)`
    grid-template-columns: 0.2fr 0.2fr 0.25fr 0.25fr 0.1fr;
`;

const TableRow = styled(PathwayTableContentRow)`
    grid-template-columns: 0.2fr 0.2fr 0.25fr 0.25fr 0.1fr;
`;

const ButtonArea = styled.div`
    display: flex;
    gap: var(--gap-s);
    justify-content: center;
`;

const IntegrationCell = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

const IntegrationLogoImg = styled.img`
    width: 20px;
    height: 20px;
    object-fit: contain;
    flex: none;
`;

const IntegrationIconFallback = styled.i`
    font-size: 14px;
    width: 20px;
    text-align: center;
    color: var(--text-muted);
    flex: none;
`;
